import React from "react";
import Button from "@material-ui/core/Button";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";

//iconos
import getCacheBustingQuery from "../../Util/getCacheBustingQuery";
import profile from "../../assets/icons/perfil.svg";
import arrow from "../../assets/icons/arrow.svg";
import set from "../../assets/icons/sign_off.svg";
import piggy from "../../assets/icons/piggy_bank.svg";
import category from "../../assets/icons/category.svg";
import datos from "../../assets/icons/datos.svg";
import datosB from "../../assets/icons/datosB.svg";
import ubicacionB from "../../assets/icons/UbicacionB.svg";
import creditoB from "../../assets/icons/creditoB.svg";
import elementosA from "../../assets/icons/elementosA.svg";
import pretamos from "../../assets/icons/prestamos.svg";
import LoadFile from "../../assets/icons/LoadFile.svg";

//signOutButton
import SignOutButton from "../../msal/SignOutButton";

//components
import * as constants from "../../global/const";
import auth from "../../Helpers/auth";

//images
import noimage from "../../assets/icons/user-solid.svg"; //imagen-DiapositivaIncompleta
import zIndex from "@material-ui/core/styles/zIndex";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  paper: {
    marginRight: theme.spacing(2),
  },
}));

export default function MenuListComposition({
  open,
  setOpen,
  setExpandedGlobal,
}) {
  /* 
    var Slider = {
      position: 'absolute',
      backgroundColor: '#fff',
      width: '80vw',
      padding: '2rem 0rem',    
      height: '80vh',
      top:'6.5rem',
      overflow: 'hidden',
      right: '0',
      opacity:'1',
      cursor: 'auto',
      borderRadius:' 20px 0  0px 20px',
      transition: 'all 0.5s',
      } 
  
      var CloseSlider = {
          right: '0',
          height: '80vh',
          top:'6.5rem',
         position: 'absolute',
         backgroundColor: '#fff',
         width: 0,
         overflow: 'hidden',
         opacity:'1',
         transition: 'all 0.5s',     
          }  */

  const [expanded, setExpanded] = React.useState(false);
  const [openSlide, setopenSlide] = React.useState(false);
  const userCurrent = JSON.parse(auth.getUsuario());
  const handleChange = () => {
    setExpandedGlobal(!expanded);
    setExpanded((expanded) => {
      return !expanded;
    });
  };
  const classes = useStyles();
  const anchorRef = React.useRef(null);

  let history = useHistory();

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }
    prevOpen.current = open;
  }, [open]);

  return (
    <div className={classes.root}>
      {}
      <div className="popper">
        <Button
          className="btn-menu"
          ref={anchorRef}
          aria-controls={open ? "menu-list-grow" : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
        ></Button>
        <Popper
          open={open}
          anchorEl={React.useRef(null)}
          role={undefined}
          transition
          disablePortal
          placement="bottom-start"
          className="miMenuChange"
          modifiers={{
            offset: {
              enabled: true,
              offset: "[0, 10]",
            },
          }}
          /* style={{ position: 'fixed', bottom: 0, right: 0, top: '60px', left: 'unset' }} */
          /*  style={{ zIndex: '100' , top: '42px' }} */
        >
          {({ TransitionProps, placement }) => (
            <Grow {...TransitionProps}>
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList
                    autoFocusItem={open}
                    id="menu-list-grow"
                    /* onKeyDown={handleListKeyDown} */ className={
                      "scrollSlider"
                    }
                  >
                    <MenuItem>
                      <div className="cerrarResponsive">
                        <button
                          className="cerrarBtn"
                          onClick={() => setOpen(false)}
                        >
                          {" "}
                          cerrar{" "}
                        </button>{" "}
                        <i className="fa fa-times-circle"> </i>
                      </div>
                      <img
                        src={`${constants.URL_BASE}ImageNit/${
                          userCurrent.urlFoto
                        }.jpg?${getCacheBustingQuery(1)}`}
                        alt=""
                        className="foto-perfil"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = noimage;
                        }}
                      />

                      <div className="negocioNombre">
                        <span className="nombreNegocio">
                          {" "}
                          {userCurrent.nombreNegocio}{" "}
                        </span>
                        <SignOutButton />
                      </div>
                    </MenuItem>

                    <hr
                      className="hr-cate"
                      size="1px"
                      width="80%"
                      align="center"
                    />
                    <MenuItem>
                      <div className={classes.root}>
                        <div className="acordeon">
                          <Accordion expanded={expanded}>
                            <AccordionSummary
                              expandIcon={
                                <div
                                  className="sect"
                                  style={{ transition: "0s" }}
                                  onClick={handleChange}
                                >
                                  <i
                                    className="select-menu"
                                    style={{
                                      bottom: expanded ? "-14px" : "-41px",
                                      left: expanded ? "-95px" : "-35px",
                                      transition: "0s",
                                    }}
                                  ></i>{" "}
                                </div>
                              }
                              aria-controls="panel1bh-content"
                              id="panel1bh-header"
                            >
                              <Typography className={classes.heading}>
                                <div className="perfil-g">
                                  {" "}
                                  <img
                                    className="fotoP"
                                    onClick={handleChange}
                                    src={profile}
                                    alt=""
                                  />
                                  <span className="perf" onClick={handleChange}>
                                    {" "}
                                    Mi perfil{" "}
                                  </span>{" "}
                                </div>
                              </Typography>
                              <hr
                                className="hr-perfil"
                                size="1px"
                                width="50%"
                                align="center"
                              />
                            </AccordionSummary>

                            <AccordionDetails>
                              <Typography>
                                <div className="section-p">
                                  <ul
                                    onClick={() =>
                                      (window.location.href =
                                        "./MiPerfil/MisDatos")
                                    }
                                  >
                                    <img
                                      className="icono-Menu"
                                      src={datosB}
                                      alt=""
                                    />
                                    <label
                                      htmlFor="abrir-datos"
                                      className="color-label"
                                    >
                                      {" "}
                                      <b> Mis datos</b>{" "}
                                    </label>{" "}
                                  </ul>
                                  {userCurrent.tipoClienteUsuario == 1 && (
                                    <ul
                                      onClick={() =>
                                        (window.location.href =
                                          "./MiPerfil/MisPuntosVenta")
                                      }
                                    >
                                      {" "}
                                      <img
                                        className="icono-Menu"
                                        src={ubicacionB}
                                        alt=""
                                      />
                                      <label
                                        htmlFor="abrir-m"
                                        className="color-label"
                                      >
                                        {" "}
                                        <b> Mis puntos de venta </b>
                                      </label>
                                    </ul>
                                  )}
                                  <ul
                                    onClick={() =>
                                      (window.location.href =
                                        "./MiPerfil/MisPedidos")
                                    }
                                  >
                                    {" "}
                                    <img
                                      className="icono-Menu"
                                      src={elementosA}
                                      alt=""
                                    />
                                    <label
                                      htmlFor="abrir-elementos"
                                      className="color-label"
                                    >
                                      {" "}
                                      <b> Mis pedidos </b>{" "}
                                    </label>{" "}
                                  </ul>
                                  {/* <ul onClick={() => window.location.href = "/MiPerfil/MisPrestamos"}><img className="icono-Menu" src={pretamos} alt="" /><label htmlFor="abrir-creditos" className="color-label" > <b> Mis elementos en prestamo  </b> </label>      </ul>
                                  {userCurrent.tipoClienteUsuario == 1 && (<ul onClick={() => window.location.href = "./MiPerfil/MiCredito"}><img className="icono-Menu" src={creditoB} alt="" /><label htmlFor="abrir-creditos" className="color-label" > <b> Mi Crédito  </b> </label></ul>)} */}
                                </div>
                              </Typography>
                            </AccordionDetails>
                          </Accordion>
                        </div>
                      </div>
                    </MenuItem>

                    <MenuItem>
                      <div
                        className="categorias"
                        onClick={() =>
                          history.push("./Catalogo/Categoria/-1/Todos/1")
                        }
                      >
                        <img className="fotoI" src={category} alt="" />
                        <span className="tile">Categorías</span>
                      </div>
                    </MenuItem>
                    <hr
                      className="hr-cate"
                      size="1px"
                      width="80%"
                      align="center"
                    />

                    {userCurrent.tipoClienteUsuario === 1 && (
                      <>
                        <MenuItem>
                          <div
                            className="categorias"
                            onClick={() =>
                              (window.location.href = "./CargaMasiva")
                            }
                          >
                            <img className="fotoI" src={LoadFile} alt="" />
                            <span className="tile"> Carga masiva</span>
                          </div>
                        </MenuItem>
                        <hr
                          className="hr-cate"
                          size="1px"
                          width="80%"
                          align="center"
                        />
                      </>
                    )}

                    <MenuItem>
                      <div
                        className="ofertas"
                        onClick={() => {
                          history.push("/Catalogo/Categoria/-4/Todos/1");
                        }}
                      >
                        <img className="fotoI" src={piggy} alt="" />
                        <span className="tile"> Ofertas </span>
                      </div>
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    </div>
  );
}
